import isEqual from 'lodash/isEqual';
import uniqWith from 'lodash/uniqWith';
import * as constants from './constants';
import controller from './controller';
import { servicesActions as servicesMobxActions } from './servicesStore';
import { store } from '../../../lib/redux';

const dispatchFail = (dispatch, failType, error, payload) => {
  dispatch({
    type: failType,
    payload: {
      loading: false,
      error,
      ...payload,
    },
  });
  throw error;
};

const getPromiseWithData = (data = {}) => {
   
  const promise = new Promise((resolve) => resolve(data));
  return promise;
};

export function resetError() {
  return dispatch => dispatch({
    type: constants.RESET_ERROR,
    payload: { error: undefined },
  });
}

export function getRoles(request) {
/*  const cacheValue = store.getState().permissions.roles;

  if (cacheValue.length > 0) {
    return dispatch => getPromiseWithData(cacheValue).then(response => {
      return dispatch({
        type: constants.FETCH_ROLES_SUCCESS,
        payload: { roles: response, error: null },
      });
    });
  } */

  return dispatch => controller.getRoles(request).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_ROLES_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_ROLES_SUCCESS,
      payload: { roles: response.data, error: undefined },
    });
  });
}

export function getPossibleParentRoles(data) {
  return dispatch => controller.getPossibleParentRoles(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_PARENT_ROLES_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_PARENT_ROLES_SUCCESS,
      payload: { possibleParentRoles: response.data, error: undefined },
    });
  });
}

export function getTemplateRoles(data) {
  return dispatch => controller.getTemplateRoles(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_TEMPLATE_ROLES_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_TEMPLATE_ROLES_SUCCESS,
      payload: { templateRoles: response.data, error: undefined },
    });
  });
}

export function createRole(params) {
  return dispatch => controller.createRole(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.CREATE_ROLE_FAIL, response.errorData);
    }

    return dispatch({ type: constants.CREATE_ROLE_SUCCESS, payload: { error: undefined } });
  });
}

export function updateRole(params) {
  return dispatch => controller.updateRole(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.UPDATE_ROLE_FAIL, response.errorData);
    }

    return dispatch({ type: constants.UPDATE_ROLE_SUCCESS, payload: { error: undefined } });
  });
}

export function deleteRole(params) {
  return dispatch => controller.deleteRole(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.DELETE_ROLE_FAIL, response.errorData);
    }

    return dispatch({ type: constants.DELETE_ROLE_SUCCESS, payload: { error: undefined } });
  });
}

export function getServices(partnerId = null) {
  if (partnerId) {
    return dispatch => controller.getServicePartner({ partnerId }).then(response => {
      if (response.errorData) {
        return dispatchFail(dispatch, constants.FETCH_SERVICES_FAIL, response.errorData);
      }

      return dispatch({
        type: constants.FETCH_SERVICES_SUCCESS,
        payload: {
          services: uniqWith(response.data
            .map(v => {
              return {
                id: v.serviceId,
                name: v.serviceName,
                stationary: v?.stationary,
                useInsurance: v?.useInsurance,
              };
            }), isEqual),
          error: undefined,
        },
      });
    });
  }

  return dispatch => controller.getServices().then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_SERVICES_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_SERVICES_SUCCESS,
      payload: { services: response.data, error: undefined },
    });
  });
}

export function getAuthenticatedPartnersServices() {
  const cacheValue = store.getState().permissions.partnerServices;

  if (cacheValue.length > 0) {
    return dispatch => getPromiseWithData(cacheValue).then(response => {
      return dispatch({
        type: constants.FETCH_SERVICES_SUCCESS,
        payload: { partnerServices: response, error: null },
      });
    });
  }

  return dispatch => controller.getAuthenticatedPartnersServices().then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_SERVICES_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_SERVICES_SUCCESS,
      payload: { partnerServices: response.data, error: undefined },
    });
  });
}

export function getAuthenticatedUserServices() {
  return dispatch => controller.getAuthenticatedUserServices().then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_SERVICES_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_SERVICES_SUCCESS,
      payload: { partnerServices: response.data, error: undefined },
    });
  });
}

export function createService(params) {
  return dispatch => controller.createService(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.CREATE_SERVICE_FAIL, response.errorData);
    }

    // сброс MobX-кэша списков сервисов (селектор кэширует на сессию)
    servicesMobxActions.clearServices();

    return dispatch({ type: constants.CREATE_SERVICE_SUCCESS, payload: { error: undefined } });
  });
}

export function updateService(params) {
  return dispatch => controller.updateService({
    ...params,
    bonusReceivingPercent: params?.bonusReceivingPercent || null,
    bonusMaxSpendingPercent: params?.bonusMaxSpendingPercent || null,
    freeOrdersQuantity: params?.freeOrdersQuantity || null,
    feeFixedPart: params?.feeFixedPart || null,
    feeRate: params?.feeRate || null,
    feeMin: params?.feeMin || null,
    feeMax: params?.feeMax || null,
  }).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.UPDATE_SERVICE_FAIL, response.errorData);
    }

    // сброс MobX-кэша списков сервисов (селектор кэширует на сессию)
    servicesMobxActions.clearServices();

    return dispatch({ type: constants.UPDATE_SERVICE_SUCCESS, payload: { error: undefined } });
  });
}

export function deleteService(params) {
  return dispatch => controller.deleteService(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.DELETE_SERVICE_FAIL, response.errorData);
    }

    // сброс MobX-кэша списков сервисов (селектор кэширует на сессию)
    servicesMobxActions.clearServices();

    return dispatch({ type: constants.DELETE_SERVICE_SUCCESS, payload: { error: undefined } });
  });
}

export function getServiceRole(params) {
  return dispatch => controller.getServiceRole(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_SERVICE_ROLE_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_SERVICE_ROLE_SUCCESS,
      // eslint-disable-next-line max-len
      payload: { serviceRoleList: response.data ? response.data?.sort((a,b) => a.name > b.name ? 1 : -1 ) : [], error: undefined },
    });
  });
}

export function createServiceRole(params) {
  return dispatch => controller.createServiceRole(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.CREATE_SERVICE_ROLE_FAIL, response.errorData);
    }

    return dispatch({ type: constants.CREATE_SERVICE_ROLE_SUCCESS, payload: { error: undefined } });
  });
}

export function deleteServiceRole(params) {
  return dispatch => controller.deleteServiceRole(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.DELETE_SERVICE_ROLE_FAIL, response.errorData);
    }

    return dispatch({ type: constants.DELETE_SERVICE_ROLE_SUCCESS, payload: { error: undefined } });
  });
}

export function getOperations(params) {
  return dispatch => controller.getOperations(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_OPERATIONS_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_OPERATIONS_SUCCESS,
      payload: { operations: response.data, error: undefined },
    });
  });
}

export function createOperation(params) {
  return dispatch => controller.createOperation(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.CREATE_OPERATION_FAIL, response.errorData);
    }

    return dispatch({ type: constants.CREATE_OPERATION_SUCCESS, payload: { error: undefined } });
  });
}

export function updateOperation(params) {
  return dispatch => controller.updateOperation(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.UPDATE_OPERATION_FAIL, response.errorData);
    }

    return dispatch({ type: constants.UPDATE_OPERATION_SUCCESS, payload: { error: undefined } });
  });
}

export function deleteOperation(params) {
  return dispatch => controller.deleteOperation(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.DELETE_OPERATION_FAIL, response.errorData);
    }

    return dispatch({ type: constants.DELETE_OPERATION_SUCCESS, payload: { error: undefined } });
  });
}

export function resetUserPermissions() {
  return dispatch => dispatch({
    type: constants.RESET_PERMISSIONS,
    payload: { permissions: [], error: undefined },
  });
}

export function getUserPermissions(params) {
  return dispatch => {
    dispatch({
      type: constants.FETCH_PERMISSIONS,
      payload: { loading: true, error: undefined },
    });

    return controller.getUserPermissions(params).then(response => {
      if (response.errorData) {
        return dispatchFail(dispatch, constants.FETCH_PERMISSIONS_FAIL, response.errorData);
      }

      return dispatch({
        type: constants.FETCH_PERMISSIONS_SUCCESS,
        payload: { permissions: response.data, loading: false, error: undefined },
      });
    });
  };
}

export function getCustomerRoles(params) {
  return dispatch => controller.getCustomerRoles(params).then(response => {
    if (response.errorData) {
      return dispatchFail(
        dispatch,
        constants.FETCH_CUSTOMER_ROLES_FAIL,
        response.errorData,
        { customerRolesUserId: null }
      );
    }

    return dispatch({
      type: constants.FETCH_CUSTOMER_ROLES_SUCCESS,
      payload: { customerRoles: response.data, customerRolesUserId: params.customerId, error: undefined },
    });
  });
}

export function updateCustomerRolesInRedux(customerRoles) {
  return dispatch => dispatch({
    type: constants.UPDATE_CUSTOMER_ROLES_REDUX,
    payload: { customerRoles, error: undefined },
  });
}

export function clearCustomerRoles() {
  return dispatch => dispatch({
    type: constants.CLEAR_PARTNER_PERMISSION_LIST,
    payload: { customerRoles: [], customerRolesUserId: null, error: undefined },
  });
}

export function createCustomerRoles(params) {
  return dispatch => controller.createCustomerRoles(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.CREATE_CUSTOMER_ROLES_FAIL, response.errorData);
    }

    return dispatch({ type: constants.CREATE_CUSTOMER_ROLES_SUCCESS, payload: { error: undefined } });
  });
}

export function deleteCustomerRoles(params) {
  return dispatch => controller.deleteCustomerRoles(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.DELETE_CUSTOMER_ROLES_FAIL, response.errorData);
    }

    return dispatch({ type: constants.DELETE_CUSTOMER_ROLES_SUCCESS, payload: { error: undefined } });
  });
}

export function getServicePartner(params) {
  return dispatch => controller.getServicePartner(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_SERVICE_PARTNER_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_SERVICE_PARTNER_SUCCESS,
      payload: { servicePartnerList: response.data, error: undefined },
    });
  });
}

export function clearServicePartner() {
  return {
    type: constants.CLEAR_SERVICE_PARTNER_SUCCESS,
    payload: { servicePartnerList: [] },
  };
}

export function createServicePartner(params) {
  return dispatch => controller.createServicePartner(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.CREATE_SERVICE_PARTNER_FAIL, response.errorData);
    }

    // сброс MobX-кэша списков сервисов (селектор кэширует на сессию)
    servicesMobxActions.clearServices();

    return dispatch({ type: constants.CREATE_SERVICE_PARTNER_SUCCESS, payload: { error: undefined } });
  });
}

export function deleteServicePartner(params) {
  return dispatch => controller.deleteServicePartner(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.DELETE_SERVICE_PARTNER_FAIL, response.errorData);
    }

    // сброс MobX-кэша списков сервисов (селектор кэширует на сессию)
    servicesMobxActions.clearServices();

    return dispatch({ type: constants.DELETE_SERVICE_PARTNER_SUCCESS, payload: { error: undefined } });
  });
}

export function getServiceUsers(params) {
  return dispatch => {
    dispatch({
      type: constants.FETCH_SERVICE_USERS,
      payload: { serviceUsersListData: params, error: undefined },
    });

    return controller.getServiceUsers(params).then(response => {
      if (response.errorData) {
        return dispatchFail(dispatch, constants.FETCH_SERVICE_USERS_FAIL, response.errorData);
      }

      return dispatch({
        type: constants.FETCH_SERVICE_USERS_SUCCESS,
        payload: { serviceUsersList: response.data, error: undefined },
      });
    });
  };
}

export function resetUserRoles() {
  return dispatch => dispatch({
    type: constants.RESET_USER_ROLES,
    payload: { userRoles: [], error: undefined },
  });
}

export function getUserRoles(params) {
  return dispatch => {
    dispatch({
      type: constants.FETCH_USER_ROLES,
      payload: { loadingUserRoles: true, error: undefined },
    });

    return controller.getCustomerRoles(params)
      .then(response => {
        if (response.errorData) {
          return dispatchFail(
            dispatch,
            constants.FETCH_USER_ROLES_FAIL,
            response.errorData,
            { loadingUserRoles: false }
          );
        }

        return dispatch({
          type: constants.FETCH_USER_ROLES_SUCCESS,
          payload: { loadingUserRoles: false, userRoles: response.data, error: undefined },
        });
      });
  };
}

export function getPermissionsByOperation(params) {
  return dispatch => controller.getPermissionsByOperation(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_PERMISSIONS_BY_OPERATION_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_OPERATIONS_SUCCESS,
      payload: { permissionsByOperation: response.data, error: undefined },
    });
  });
}

export function getPartnerPermissions(params) {
  return dispatch => {
    dispatch({
      type: constants.FETCH_PARTNER_PERMISSIONS,
      payload: {
        loadingPartnerPermissionList: true,
        partnerPermissionListPartnerId: params.partnerId,
        partnerPermissionList: [],
        error: undefined,
      },
    });

    return controller.getPartnerPermissions(params)
      .then(response => {
        if (response.errorData) {
          return dispatchFail(
            dispatch,
            constants.FETCH_PARTNER_PERMISSIONS_FAIL,
            response.errorData,
            { loadingPartnerPermissionList: false }
          );
        }

        return dispatch({
          type: constants.FETCH_PARTNER_PERMISSIONS_SUCCESS,
          payload: { loadingPartnerPermissionList: false, partnerPermissionList: response.data, error: undefined },
        });
      });
  };
}

export function postPartnerPermissions(params) {
  return dispatch => controller.postPartnerPermissions(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.POST_PARTNER_PERMISSION_FAIL, response.errorData);
    }

    return dispatch({ type: constants.POST_PARTNER_PERMISSION_SUCCESS, payload: { error: undefined } });
  });
}

export function clearPartnerPermissions() {
  return dispatch => dispatch({
    type: constants.CLEAR_PARTNER_PERMISSION_LIST,
    payload: { partnerPermissionList: [], partnerPermissionListPartnerId: undefined, error: undefined },
  });
}
